<template>
  <el-card
      class="refund-shipping-card"
      :class="{ 'highlighted-refund-shipping-card': refundShipping }">
    <div class="flex-auto">
      <div class="flex flex-row">
        <div class="shipping-refund-info flex-auto">
          {{
            isShippingRefundDisabled
              ? "No shipping costs to refund (Shipping refund may have been issued already)"
              : "Refund the shipping cost?"
          }}
        </div>
      </div>
      <div class="flex flex-row">
        <div class="shipping-refund-amount">
          Refundable Shipping Amount:&nbsp;<span
              style="font-weight: bold;">${{ shippingTotal }}</span>
        </div>
      </div>
    </div>
    <el-checkbox
        :disabled="isShippingRefundDisabled"
        :value="refundShipping"
        @change="toggleSelection" />
  </el-card>
</template>

<script>
export default {
  name: "RefundShippingCard",
  props: {
    refundShipping: {
      type: Boolean,
      default: false,
    },
    shippingTotal: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isShippingRefundDisabled() {
      return this.shippingTotal <= 0;
    },
  },
  methods: {
    toggleSelection(value) {
      this.$emit("update:refundShipping", value);
    },
  },
};
</script>

<style scoped>
.refund-shipping-card {
  box-shadow: none !important;
  box-sizing: border-box;
  align-items: center;
  padding: 16px 24px;
  min-height: 80px !important;

  &.highlighted-refund-shipping-card {
    background: #eff8fc;
    border: 2px solid #1998d5;
    border-radius: 4px;
  }

  .shipping-refund-info {
    font-size: 16px;
    font-weight: 500;
  }
  .shipping-refund-amount {
    height: 24px;
    font-family: "Equip", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 2px;
  }
}
</style>
